import React from "react";

export interface FilterChipGroupProps {
  options: string[];
  selectedOption: string | null;
  onChange: (option: string | null) => void;
}

const FilterChipGroup = ({
  options,
  selectedOption,
  onChange,
}: FilterChipGroupProps) => {
  return (
    <>
      {options.map((option) => (
        <button
          key={option}
          type="button"
          className={`cursor-pointer shrink-0 flex items-center justify-center px-3 py-2 min-h-11 border-2 rounded-lg transition-colors text-sm text-center whitespace-nowrap ${
            selectedOption === option
              ? "border-electrum bg-electrum-100 font-medium"
              : "bg-white border-gray hover:border-electrum"
          }`}
          onClick={() => onChange(selectedOption === option ? null : option)}
        >
          {option}
        </button>
      ))}
    </>
  );
};

export default FilterChipGroup;
